import { BaseModel } from './base.model';

export class HeaderDefaultItemModel extends BaseModel {
    response: string;
    header_item_type: number;
    list_id: number;
    header_item_id: number;
    header_default_id: number;

    description: string;

    constructor(response, header_item_type, list_id, header_item_id, header_default_id, description) {
        super();
        this.response = response;
        this.description = description;
        this.header_item_type = header_item_type;
        this.list_id = list_id;
        this.header_item_id = header_item_id;
        this.header_default_id = header_default_id;
    }
}


// WEBPACK FOOTER //
// C:/Users/Emanuel/Documents/EasyCheck/easy-check-front-web/src/app/shared/model/header-default-item.model.ts